(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bb-wrapper').forEach(function (root) {
    var sectionId   = root.id;
    var minProducts = parseInt(root.dataset.minProducts || '4', 10);
    var discountCode = root.dataset.discountCode || '';
    var currency = root.dataset.currency || 'PKR';

    var intro   = root.querySelector('[id^="bbIntro-"]');
    var builder = root.querySelector('[id^="bbBuilder-"]');
    var getStartedBtn = root.querySelector('[id^="bbGetStarted-"]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.bb-step'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.bb-dot'));
    var stickyBar = root.querySelector('[id^="bbStickyBar-"]');
    var stickyCount = root.querySelector('[id^="bbStickyCount-"]');
    var stickyTotal = root.querySelector('[id^="bbStickyTotal-"]');
    var summaryList = root.querySelector('[id^="bbSummaryList-"]');
    var subtotalEl = root.querySelector('[id^="bbSubtotal-"]');
    var discountAmtEl = root.querySelector('[id^="bbDiscountAmt-"]');
    var finalTotalEl = root.querySelector('[id^="bbFinalTotal-"]');
    var minWarning = root.querySelector('[id^="bbMinWarning-"]');
    var checkoutBtn = root.querySelector('[id^="bbCheckoutBtn-"]');
    var unlockModal = root.querySelector('[id^="bbUnlock-"]');
    var unlockClose = root.querySelector('[id^="bbUnlockClose-"]');
    var unlockCta = root.querySelector('[id^="bbUnlockCta-"]');
    var confettiHost = root.querySelector('[id^="bbConfetti-"]');

    var currentStep = 0;
    var selections = {}; // stepIndex -> { variantId, price, title, image }

    var moneyFormatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol'
    });
    function fmt(amount) {
      try { return moneyFormatter.format(amount); }
      catch (e) { return currency + ' ' + amount.toFixed(2); }
    }

    function showStep(index) {
      steps.forEach(function (step) {
        step.hidden = parseInt(step.dataset.stepIndex, 10) !== index;
      });
      dots.forEach(function (dot) {
        var i = parseInt(dot.dataset.dotIndex, 10);
        dot.classList.toggle('is-active', i === index);
        dot.classList.toggle('is-done', i < index);
      });
      currentStep = index;
      if (index === steps.length - 1) renderSummary();
    }

    function calcTotals() {
      var subtotal = 0;
      Object.keys(selections).forEach(function (k) { subtotal += selections[k].price; });
      var discountRate = 0.10;
      var discount = subtotal * discountRate;
      return { subtotal: subtotal, discount: discount, total: subtotal - discount };
    }

    function updateStickyBar() {
      var count = Object.keys(selections).length;
      var totals = calcTotals();
      stickyCount.textContent = count + (count === 1 ? ' product selected' : ' products selected');
      stickyTotal.textContent = fmt(totals.subtotal);
      stickyBar.hidden = count === 0;
    }

    function renderSummary() {
      summaryList.innerHTML = '';
      var keys = Object.keys(selections);
      if (keys.length === 0) {
        summaryList.innerHTML = '<p class="bb-empty" style="padding:16px;">No products selected yet.</p>';
      }
      keys.forEach(function (k) {
        var item = selections[k];
        var row = document.createElement('div');
        row.className = 'bb-summary-item';
        row.innerHTML =
          '<img src="' + item.image + '" alt="">' +
          '<span class="bb-summary-item-title">' + item.title + '</span>' +
          '<span class="bb-summary-item-price">' + fmt(item.price) + '</span>';
        summaryList.appendChild(row);
      });

      var totals = calcTotals();
      subtotalEl.textContent = fmt(totals.subtotal);
      discountAmtEl.textContent = '-' + fmt(totals.discount);
      finalTotalEl.textContent = fmt(totals.total);

      var enough = keys.length >= minProducts;
      minWarning.hidden = enough;
      checkoutBtn.disabled = !enough;
    }

    // Get started
    getStartedBtn.addEventListener('click', function () {
      intro.hidden = true;
      builder.hidden = false;
      showStep(0);
    });

    // ---- Unlock 10% off popup + confetti ----
    var confettiColors = ['#282828', '#e91e8c', '#7c3aed', '#f5c518', '#10b981'];

    function fireConfetti() {
      if (!confettiHost) return;
      for (var i = 0; i < 70; i++) {
        var piece = document.createElement('span');
        piece.className = 'bb-confetti-piece';
        piece.style.left = Math.random() * 100 + 'vw';
        piece.style.background = confettiColors[Math.floor(Math.random() * confettiColors.length)];
        piece.style.animationDuration = (2.2 + Math.random() * 1.3) + 's';
        piece.style.animationDelay = (Math.random() * 0.4) + 's';
        piece.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
        confettiHost.appendChild(piece);
        (function (el) {
          el.addEventListener('animationend', function () { el.remove(); });
        })(piece);
      }
    }

    function showUnlockPopup() {
      if (!unlockModal) return;
      unlockModal.hidden = false;
      requestAnimationFrame(function () {
        unlockModal.classList.add('is-visible');
        fireConfetti();
      });
    }

    function hideUnlockPopup() {
      if (!unlockModal) return;
      unlockModal.classList.remove('is-visible');
      setTimeout(function () { unlockModal.hidden = true; }, 250);
    }

    if (unlockClose) unlockClose.addEventListener('click', hideUnlockPopup);
    if (unlockModal) unlockModal.addEventListener('click', function (e) {
      if (e.target === unlockModal) hideUnlockPopup();
    });
    if (unlockCta) unlockCta.addEventListener('click', hideUnlockPopup);

    // Show the popup shortly after the section loads (once per browser session)
    var alreadySeen = false;
    try { alreadySeen = sessionStorage.getItem('bb_unlock_seen_' + sectionId) === '1'; } catch (e) {}
    if (!alreadySeen) {
      setTimeout(function () {
        showUnlockPopup();
        try { sessionStorage.setItem('bb_unlock_seen_' + sectionId, '1'); } catch (e) {}
      }, 500);
    }

    // Card selection (event delegation)
    root.addEventListener('change', function (e) {
      if (!e.target.classList.contains('bb-radio')) return;
      var stepEl = e.target.closest('.bb-step');
      var stepIndex = parseInt(stepEl.dataset.stepIndex, 10);
      selections[stepIndex] = {
        variantId: e.target.dataset.variantId,
        price: parseFloat(e.target.dataset.price),
        title: e.target.dataset.title,
        image: e.target.dataset.image
      };
      updateStickyBar();
    });

    // Next / Back / Skip
    root.addEventListener('click', function (e) {
      if (e.target.classList.contains('bb-next')) {
        showStep(Math.min(currentStep + 1, steps.length - 1));
      }
      if (e.target.classList.contains('bb-skip')) {
        var stepEl = e.target.closest('.bb-step');
        var stepIndex = parseInt(stepEl.dataset.stepIndex, 10);
        delete selections[stepIndex];
        updateStickyBar();
        showStep(Math.min(currentStep + 1, steps.length - 1));
      }
      if (e.target.classList.contains('bb-back')) {
        showStep(Math.max(currentStep - 1, 0));
      }
    });

    // Checkout
    checkoutBtn.addEventListener('click', function () {
      var keys = Object.keys(selections);
      if (keys.length < minProducts) {
        minWarning.hidden = false;
        return;
      }

      var items = keys.map(function (k) {
        return { id: selections[k].variantId, quantity: 1 };
      });

      checkoutBtn.disabled = true;
      checkoutBtn.querySelector('.bb-btn-text').style.visibility = 'hidden';
      checkoutBtn.querySelector('.bb-spinner').hidden = false;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not add products to cart');
          return res.json();
        })
        .then(function () {
          var redirectPath = discountCode
            ? '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout'
            : '/checkout';
          window.location.href = redirectPath;
        })
        .catch(function (err) {
          console.error(err);
          checkoutBtn.disabled = false;
          checkoutBtn.querySelector('.bb-btn-text').style.visibility = 'visible';
          checkoutBtn.querySelector('.bb-spinner').hidden = true;
          alert('Something went wrong adding your bundle to the cart. Please try again.');
        });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();
})();
